import Box from '@mui/material/Box';
import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import React from 'react';
import Typography from '@mui/material/Typography';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { HButton } from 'BaseComponents';
import { IconButton } from '@mui/material';
import { StyledDialogTitle } from 'components/CleanRooms/CrManagement/AWSAccountSettings/style';


export const WarningDialog = ({
  open,
  title,
  message,
  onCancel,
  onConfirm,
  warningActionLabel,
  confirmText,
  colorIcon,
  maxWidth = 'xs',
}) => (
  <Dialog
    open={open}
    onClose={onCancel}
    fullWidth
    maxWidth={maxWidth}
  >
    <StyledDialogTitle>
      <Box display='flex' alignItems='center'>
        <WarningAmberIcon fontSize='large' sx={{ color: colorIcon }} />
        <Typography variant='h3'>
          {title}
        </Typography>
      </Box>
      <IconButton
        onClick={onCancel}
      >
        <CloseIcon fontSize='large' />
      </IconButton>
    </StyledDialogTitle>
    <DialogContent dividers>
      <Box display='flex' flexDirection='column' gap='24px'>
        <Typography variant='body1' gutterBottom sx={{ whiteSpace: 'pre-line' }}>
          {message}
        </Typography>
        <Typography variant='body1' gutterBottom>
          {confirmText}
        </Typography>
      </Box>
    </DialogContent>
    <DialogActions>
      <HButton variant='outlined' onClick={onCancel} size='medium' data-testid='cancel-button'>
        Cancel
      </HButton>
      <HButton
        variant='contained'
        color='primary'
        size='medium'
        onClick={onConfirm}
      >
        {warningActionLabel}
      </HButton>
    </DialogActions>
  </Dialog>
);
